import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesOrderService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) {}

  createFormData(salesOrder: any): FormData {
    //// debugger
    if (salesOrder.transactionDate && typeof salesOrder.transactionDate !== 'string') {
      salesOrder.transactionDate = (new Date(salesOrder.transactionDate)).toISOString();
    }
    const formData = new FormData();

    // Add id field
    formData.append('id', salesOrder.id?.toString() || '0');
  
    // Append main properties
    formData.append('customerId', salesOrder.customerId?.toString() || '');
    formData.append('factoryId', salesOrder.factoryId?.toString() || '');
    formData.append('salesManId', salesOrder.salesManId?.toString() || '');
    formData.append('status', salesOrder.status?.toString() || '');
    formData.append('transactionDate', salesOrder.transactionDate || '');
    formData.append('total', salesOrder.total?.toString() || '0');
    formData.append('totalBeforeVAT', salesOrder.totalBeforeVAT?.toString() || '0');
    formData.append('vatAmount', salesOrder.vatAmount?.toString() || '0');
    formData.append('vatPercentage', salesOrder.vatPercentage?.toString() || '0');
    formData.append('notes', salesOrder.notes?.toString() || '');
    formData.append('basePurchaseOrderId', salesOrder.basePurchaseOrderId?.toString() || '');
    
    //formData.append('parentSalesOrderId', salesOrder.parentSalesOrderId?.toString() || '');
   // formData.append('customerAddressId', salesOrder.customerAddressId?.toString() || '');
  
    // Handle sales order lines
    if (salesOrder.salesOrderLines?.length > 0) {
      salesOrder.salesOrderLines.forEach((line, index) => {
        // Include line id for updates
        formData.append(`SalesOrderLines[${index}].Id`, line.id?.toString() || '0');
        formData.append(`SalesOrderLines[${index}].ItemId`, line.itemId?.toString() || '');
        formData.append(`SalesOrderLines[${index}].Quantity`, line.quantity?.toString() || '0');
        formData.append(`SalesOrderLines[${index}].Total`, line.total?.toString() || '0');
        formData.append(`SalesOrderLines[${index}].TotalBeforeVAT`, line.totalBeforeVAT?.toString() || '0');
        formData.append(`SalesOrderLines[${index}].UnitPrice`, line.unitPrice?.toString() || '0');
        formData.append(`SalesOrderLines[${index}].UOM`, line.uom || '');
        formData.append(`SalesOrderLines[${index}].VATAmount`, line.vatAmount?.toString() || '0');
        formData.append(`SalesOrderLines[${index}].VATPercentage`, line.vatPercentage?.toString() || '0');
        formData.append(`SalesOrderLines[${index}].customerAddressId`, line.customerAddressId?.toString() || '0');
       // formData.append(`SalesOrderLines[${index}].customerAddress`, line.customerAddress?.toString() || '');

        // Add sales quotation reference fields if they exist
        if (line.salesQuotationId) {
          formData.append(`SalesOrderLines[${index}].parentSalesQuotationId`, line.salesQuotationId?.toString() || '');
          formData.append(`SalesOrderLines[${index}].ParentSalesQuotationLineId`, line.salesQuotationLineId?.toString() || '');
        }
      });
    }
      // Handle document attachments
  if (salesOrder.documentAttachments?.length > 0) {
    salesOrder.documentAttachments.forEach((attachment, index) => {
      // Include attachment id for updates
      formData.append(`DocumentAttachments[${index}].Id`, attachment.id?.toString() || '0');
      formData.append(`DocumentAttachments[${index}].Filename`, attachment.filename || '');
      // Only append file content if it's a new file (Blob/File object)
      if (attachment.fileContent instanceof Blob) {
        formData.append(`DocumentAttachments[${index}].FileContent`, attachment.fileContent);
      }
      // Include path for existing files
      if (attachment.path) {
        formData.append(`DocumentAttachments[${index}].Path`, attachment.path);
      }
    });
  }

  // Log FormData contents for debugging
  (formData as any).forEach((value: any, key: string) => {
   // console.log(`${key}: ${value}`);
  });


  return formData;
  }
  
  getAllSalesOrders() {
    return this.http.get<any>(`${this._baseUrl}/SalesOrder`);
  }

  getPaginatedSalesOrders(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/SalesOrder/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }

  getSalesOrderById(id: number) {
    return this.http.get<any>(`${this._baseUrl}/SalesOrder/${id}`);
  }

  deleteSalesOrder(id: number) {
    return this.http.delete<any>(`${this._baseUrl}/SalesOrder/${id}`);
  }

  addNewSalesOrder(salesOrder: any) {
    // // debugger;
    const formData = this.createFormData(salesOrder);
    return this.http.post<any>(`${this._baseUrl}/SalesOrder/Add`, formData);
  }

  updateSalesOrder(id: number, salesOrder: any) {
    const formData = this.createFormData(salesOrder);
    return this.http.patch<any>(
      `${this._baseUrl}/SalesOrder/${id}`,
      formData
    );
  }
  getUnitPriceForCustomer(customerId: number, productId: number,customerAddressId:number) {
    const params = new HttpParams()
      .set('customer_id', customerId.toString())
      .set('product_id', productId.toString())
      .set('customerAddressId', customerAddressId.toString());
console.log(`${this._baseUrl}/SalesOrder/UnitPriceForCustomer`, { params });
    return this.http.get<any>(`${this._baseUrl}/SalesOrder/UnitPriceForCustomer`, { params });
  }
}
